import './App.css';
import HomePage from './pages/page';

function App() {
  return (
    <>
      <HomePage />
    </>
  );
}

export default App;
